import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

import { ResetPasswordPage } from "@/features/auth";

/**
 * `token` is the only URL-carried piece of reset-password state. It's a
 * one-time reset token, not PHI/credential material persisted anywhere —
 * it lives only in this query param, matching the documented reset flow.
 */
const resetPasswordSearchSchema = z.object({
  token: z.string().optional().catch(undefined),
});

export const Route = createFileRoute("/reset-password")({
  validateSearch: resetPasswordSearchSchema,
  component: ResetPasswordPage,
});
